import { styled } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.PADDING.MD};
  border: 1px dashed ${({ theme }) => theme.COLORS.GRAY_MEDIUM};
  border-radius: 8px;
  gap: ${({ theme }) => theme.SPACING.MD};
  background-color: ${({ theme }) => theme.COLORS.LIGHT_ACTION_BLUE};
`;

export const HiddenFileInput = styled.input`
  margin-top: ${({ theme }) => theme.MARGIN.SM};
  padding: ${({ theme }) => theme.PADDING.SM};
  border: 1px solid #ccc;
  border-radius: 4px;
  opacity: 0;
  width: 0.1px;
  height: 0.1px;
  position: absolute;
`;

export const FileInputButtonWraper = styled.div`
  display: flex;
  align-items: center;
`;
export const ErrorMessage = styled.div`
  color: ${({ theme }) => theme.COLORS.ERROR};
  font-size: ${({ theme }) => theme.FONT.SIZE.SMALL};
`;

export const SuccessMessage = styled.div`
  color: ${({ theme }) => theme.COLORS.SUCCESS};
  margin-top: ${({ theme }) => theme.MARGIN.SM};
  font-size: ${({ theme }) => theme.FONT.SIZE.SMALL};
  display: flex;
  align-items: center;
`;

export const Divider = styled.hr`
  border: 0;
  border-bottom: 1px dashed ${({ theme }) => theme.COLORS.GRAY_MEDIUM};
  background: ${({ theme }) => theme.COLORS.GRAY_MEDIUM};
  margin: 0;
`;
